import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatCurrency, generateId, shortHandDate, statusColors } from '../../../utility/functions';
import Dot from '../../../Dot';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';
import Button from '../../../forms/Button';
import Modal from '../../../Modal';
import Form from '../../../forms/Form';
import HamQuest from '../../../api/HamQuestGiver';
import Select from '../../../forms/Select';
import { HSOptions } from '../../../../constants/HSOptions';
import Row from '../../../layout/Row';
import { IsAuthorized, userRoles } from '../../../RoleProtected';
import ModalFactory from '../../../Modal';

const Invoices = ({ endpoint = QuestRoute.reports.invoices, justReport, ...props }) => {

    const isAuthorized = IsAuthorized(userRoles.viewCustomers);

    const updateStatus = (invoiceId, status) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Update Invoice Status',
            body: (
                <Form
                    inputs={{
                        status: status,
                        paymentType: '',
                    }}
                    onSubmit={e => (
                        HamQuest.put(QuestRoute.invoice.status(invoiceId), { ...e })
                            .then(res => {
                                window.DateRange()
                                ModalFactory.close(id);
                            })
                    )}
                    text='Update'
                    submitting='Updating'
                >
                    {({ values }) => (
                        <>
                            <Select
                                label='Status'
                                name='status'
                                options={HSOptions.invoice.status}
                                nullable
                                required
                            />
                            {values.status === 'Paid' &&
                                <Select
                                    label='Payment Type'
                                    name='paymentType'
                                    options={HSOptions.invoice.paymentType}
                                    required
                                />}
                        </>
                    )}

                </Form>
            )
        })
    }

    const tableConfig = {
        endpoint: endpoint,
        isReport: true,
        searchLimit: justReport ? 366 : 91,
        startDate: justReport ? new Date(new Date().setFullYear(new Date().getFullYear() - 1)) : false,
        colSpacing: [10, 5, 7, 10, 18, 7,8, 8, 7, 20],
        headers: [
            {
                label: 'Name',
                propKey: 'accountName',
            }, {
                label: 'ID',
                propKey: 'invoiceId',
            }, {
                label: 'Date',
                propKey: 'invoiceDate',
                type: 'date'
            }, {
                label: 'Club Status',
                propKey: 'clubStatus',
                options: true
            }, {
                label: 'Status',
                propKey: 'invoiceStatus',
                options: true
            }, {
                label: 'Total',
                propKey: 'total',
            }, {
                label: 'Billing',
                propKey: 'isAutoBilled',
                options: true
            }, {
                label: 'Paid',
                propKey: 'datePaid',
                type: 'date'
            }, {
                label: 'Record',
                propKey: 'transRecordId',
            },
            {
                label: 'Description',
                propKey: 'description',
            }
        ],
        quickSort: justReport ? false : [
            {
                label: 'Paid',
                propKey: 'invoiceStatus',
                query: 'Paid',
                color: '#21D59B'
            }, {
                label: 'Pending',
                propKey: 'invoiceStatus',
                query: 'Pending',
                color: '#ffb100'
            }, {
                label: 'Charge Error',
                propKey: 'invoiceStatus',
                query: 'ChargeError',
                color: '#bf0d14'
            }, {
                label: 'Error',
                propKey: 'invoiceStatus',
                query: 'Error',
                color: '#ff3737'
            }, {
                label: 'Canceled',
                propKey: 'invoiceStatus',
                query: 'Canceled',
                color: '#44474e'
            }, {
                label: 'Automatic Billing',
                propKey: 'isAutoBilled',
                query: 'true',
                color: '#b5a4e8'
            }, {
                label: 'Manual Billing',
                propKey: 'isAutoBilled',
                query: 'false',
                color: '#a77b61'
            }
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>
                    {isAuthorized ?
                        <LinkTo toAccount={e}>{e.accountName}</LinkTo> : <div>{e.accountName}</div>}
                </td>
                <td>
                    <LinkTo target='_blank' to={'/reporting/Sales/Invoice/' + e.invoiceId}>{e.invoiceId}</LinkTo>
                </td>
                <td>{shortHandDate(e.invoiceDate)}</td>
                <td>
                    <Row>
                        <Dot color={statusColors[e.clubStatus]} />
                        <span>
                            {e.clubStatus}
                        </span>
                    </Row>
                </td>
                <td title={[e.invoiceStatus, e.paymentStatus].filter(e => e).join(' - ')}>
                    {(e.invoiceStatus === 'Pending' || e.invoiceStatus === 'ChargeError') ?
                        <>
                            <Button onClick={() => updateStatus(e.invoiceId, e.invoiceStatus)}>
                                <Dot color={statusColors[e.invoiceStatus]} />
                                {e.invoiceStatus}
                            </Button>
                            <span>{e.paymentStatus}</span>
                        </>
                        :
                        <Row>
                            <Dot color={statusColors[e.invoiceStatus]} />
                            <span>
                                {(e.invoiceStatus !== 'Paid' && e.invoiceStatus !== 'Canceled') ? e.paymentStatus ? e.paymentStatus : e.invoiceStatus : e.invoiceStatus}
                            </span>
                        </Row>
                    }
                </td>
                <td>{formatCurrency(e.total)}</td>
                <td>{e.isAutoBilled ? 'Automatic' : 'Manual'}</td>
                <td>{shortHandDate(e.datePaid)}</td>
                <td><LinkTo
                    target='_blank'
                    to={'/reporting/sales/transaction/' + e.transRecordId}>{e.transRecordId}</LinkTo></td>
                <td>{e.description ?? '-'}</td>
            </tr>
        )
    }

    return <Table config={tableConfig} />
}

export default Invoices;